import React from 'react';
import Modal from 'react-modal';

Modal.setAppElement('#root');

const ErrorModal = ({ isOpen, closeModal }) => (
  <Modal
    isOpen={isOpen}
    onRequestClose={closeModal}
    contentLabel="ErrorModal"
    closeTimeoutMS={200}
    className="modal modal--error"
  >
    <h3 className="modal__title modal__title--error">Vlastné zdroje nesmú prevyšovať hodnotu nehnuteľnosti!</h3>
    <button className="btn btn--error" type="button" onClick={closeModal}>Späť</button>
  </Modal>
);


export default ErrorModal;
